<script setup>
import { ref } from 'vue';
import { ModalsContainer } from 'vue-final-modal';
import 'vue-final-modal/style.css';

import FormStepCarousel from './FormStepCarousel.vue';
import InitialDeclaration from './pages/InitialDeclaration.vue';

const props = defineProps({
    insurer: {
        type: String,
        required: true
    },
    logo: {
        type: String,
        required: true
    },
    pds: {
        type: String,
        default: ''
    }
});

const insurers = {
    tal: {
        name: 'TAL',
        url: 'https://www.tal.com.au/',
        steps: [
            'lifeInsuredDetails',
            'applicationDeclaration',
            'policyAuthority',
            'medicalConsentAuthorityTal',
            'finalDeclaration'
        ]
    },
    aia: {
        name: 'AIA',
        url: 'https://www.aia.com.au/',
        steps: [
            'lifeInsuredDetails',
            'applicationDeclaration',
            'medicalConsentAuthorityAia',
            'finalDeclaration'
        ]
    },
    acenda: {
        name: 'Acenda',
        url: 'https://www.acenda.com.au/',
        steps: ['lifeInsuredDetails', 'applicationDeclaration', 'finalDeclaration']
    },
    onepath: {
        name: 'OnePath',
        url: 'https://www.onepath.com.au/',
        steps: [
            'lifeInsuredDetails',
            'applicationDeclaration',
            'medicalConsentAuthorityOnePath',
            'finalDeclaration'
        ]
    },
    zurich: {
        name: 'Zurich',
        url: 'https://www.zurich.com.au/',
        steps: [
            'lifeInsuredDetails',
            'applicationDeclaration',
            'medicalConsentAuthorityZurich',
            'finalDeclaration'
        ]
    }
};
const insurerData = {
    ...insurers[props.insurer],
    logo: props.logo,
    pds: props.pds
};

const declarationAccepted = ref(false);
const advanceStep = () => {
    declarationAccepted.value = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
};
</script>

<template>
    <div class="sm:tw-bg-grey-200 tw-bg-white DeclarationForm">
        <Transition name="slide" mode="out-in">
            <FormStepCarousel v-if="declarationAccepted" :insurer="insurerData" />
            <InitialDeclaration v-else :insurer="insurerData" @advance-step="advanceStep" />
        </Transition>

        <ModalsContainer />
    </div>
</template>

<style>
.DeclarationForm .form-panel {
    @apply tw-bg-white tw-p-4 sm:tw-p-10 tw-text-sm md:tw-text-base tw--mx-4 sm:tw--mx-0;
}

.DeclarationForm .panel-heading {
    @apply tw-text-center tw-mb-8 sm:tw-mb-12 tw-max-w-[600px] tw-mx-auto;
}
</style>
